/* Ported from frontend/assets/js/main.js initTabGroups() — handles the
   homepage's [data-tab-group] toggle sections (e.g. "Where Do You Use It?",
   "Wait, There's More..."). Without this, clicking a tab button does nothing. */
(function () {
  function initTabGroups() {
    document.querySelectorAll('[data-tab-group]').forEach(function (group) {
      var tabs = group.querySelectorAll('[data-tab]');
      var panels = group.querySelectorAll('[data-tab-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-tab');
          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          tab.classList.add('is-active');
          panels.forEach(function (p) {
            p.style.display = p.getAttribute('data-tab-panel') === target ? '' : 'none';
          });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initTabGroups);
  document.addEventListener('shopify:section:load', initTabGroups);
})();

/* Accordion toggle — event delegation (no per-element listener to conflict
   with gymskyns-product.js's own accordion handler on product pages). */
document.addEventListener('click', function (e) {
  var trigger = e.target.closest('[data-accordion-trigger]');
  if (!trigger) return;
  e.preventDefault();
  var panel = trigger.nextElementSibling;
  if (!panel) return;
  trigger.classList.toggle('is-open');
  panel.classList.toggle('is-open');
});
